var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5645 11.2545H11.7705L11.4945 10.9805C12.4695 9.84348 13.0625 8.36948 13.0625 6.75448C13.0625 3.16448 10.1525 0.254484 6.5625 0.254484C2.9725 0.254484 0.0625 3.16448 0.0625 6.75448C0.0625 10.3445 2.9725 13.2545 6.5625 13.2545C8.1775 13.2545 9.6505 12.6625 10.7875 11.6885L11.0635 11.9625V12.7545L16.0615 17.7455L17.5525 16.2545L12.5645 11.2545ZM6.5625 11.2545C4.0765 11.2545 2.0625 9.24048 2.0625 6.75448C2.0625 4.26948 4.0765 2.25448 6.5625 2.25448C9.0475 2.25448 11.0625 4.26948 11.0625 6.75448C11.0625 9.24048 9.0475 11.2545 6.5625 11.2545Z",
    fill: "#979DA5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/Search.8b768ee2a43f228d20bf550fcef229a0.svg";
export { ForwardRef as ReactComponent };